import React from 'react'
import { Button, ChevronRightIcon } from '@diversioteam/diversio-ds'
import { Skeleton } from '@material-ui/lab'

import * as S from './../panel.styles'

export const ListItemSkeleton = () => {
    return (
        <S.ListItemWrapper>
            <S.ListItemLabel>
                <Skeleton width={80} />
            </S.ListItemLabel>

            <Button color="transparent" iconOnly>
                <ChevronRightIcon type="line" />
            </Button>
        </S.ListItemWrapper>
    )
}
